(function () {
  var LIMIT = 40;

  var SELECTORS = [
    "span.link--hover-underline",
    ".productView-title",
    "h1.product__title",
    ".product-title",
    ".product-single__title"
  ].join(",");

  function truncate(el) {
    if (!el) return;

    var full = el.getAttribute("data-fulltext");
    if (!full) {
      full = (el.textContent || "").trim();
      el.setAttribute("data-fulltext", full);
    }

    if (!el.getAttribute("title")) el.setAttribute("title", full);

    el.textContent = full.length > LIMIT ? full.slice(0, LIMIT) + "…" : full;
  }

  function apply(root) {
    var els = (root || document).querySelectorAll(SELECTORS);
    for (var i = 0; i < els.length; i++) truncate(els[i]);
  }

  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      apply(document);
    });
  }

  function boot() {
    apply(document);

    // Throttled observer (prevents infinite loops)
    var obs = new MutationObserver(function () {
      scheduleApply();
    });
    obs.observe(document.body, { childList: true, subtree: true });

    // Also re-run after full load (some themes render late)
    window.addEventListener("load", function () {
      apply(document);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
